import type { ComponentProps } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import FormField from '@/shared/ui/FormField';
import { iconButtonClass } from '@/shared/ui/formClasses';

const toggleClass = `${iconButtonClass.replace('h-9 w-9', 'h-7 w-7')} pointer-events-auto hover:bg-muted hover:text-link`;

type PasswordFieldProps = Omit<
  ComponentProps<typeof FormField>,
  'type' | 'trailing' | 'options' | 'rows'
> & {
  visible: boolean;
  onToggleVisible?: () => void;
};

/** Un campo password; con `onToggleVisible` ha il pulsante che la mostra e la nasconde. */
export default function PasswordField({
  visible,
  onToggleVisible,
  ...fieldProps
}: PasswordFieldProps) {
  return (
    <FormField
      {...fieldProps}
      type={visible ? 'text' : 'password'}
      trailing={
        onToggleVisible && (
          <button
            type="button"
            onClick={onToggleVisible}
            aria-label={visible ? 'Nascondi password' : 'Mostra password'}
            className={toggleClass}
          >
            {visible ? (
              <EyeOff className="h-3.5 w-3.5" aria-hidden />
            ) : (
              <Eye className="h-3.5 w-3.5" aria-hidden />
            )}
          </button>
        )
      }
    />
  );
}
